export default function getAdmin(loginUser) {
  const user = loginUser ? loginUser.user.user : {};
  return user.admin;
}
